/**
 * Datentypen der Container-Eigenschaften — Ersatz für
 * `typeof(Container).GetProperty(FieldName).PropertyType`.
 *
 * Die Reihenfolge der Schlüssel bestimmt die Feldliste (`containerFieldNames`).
 */

import type { Container } from '../entities';
import type { ColumnValueType } from '../fieldTypes';
import { baseEntityFieldTypes } from './base';

export const containerFieldTypes: Readonly<Record<keyof Container, ColumnValueType>> = {
  AenderungCif: 'boolean',
  Anlieferdatum: 'date',
  AnlieferdatumEmpf: 'date',
  AnlieferdatumIst: 'date',
  Anlieferuhrzeit: 'string',
  Bemerkung: 'string',
  Bestellpositionen: 'string',
  Bestellpositionen_Anzahl: 'integer',
  Bestellpositionen_Artikelnummern: 'string',
  Bestellpositionen_Bezeichnungen1: 'string',
  Bestellpositionen_CBM: 'number',
  Bestellpositionen_Mengen: 'string',
  Bestellpositionen_SageBuchungDatum: 'date',
  BlNummer: 'string',
  Containerleerrueckgabe: 'string',
  ContainerNo: 'string',
  ContReturnDatum: 'date',
  ContTyp: 'string',
  DatumZugestellt: 'date',
  DepotDatum: 'date',
  DepotName: 'string',
  EingangErledigt: 'boolean',
  Empfaenger: 'string',
  Entladedatum: 'date',
  Eta: 'date',
  Etd: 'date',
  FruehestAnlieferdatum: 'date',
  GateOutDatum: 'date',
  InWochen: 'integer',
  Kw: 'string',
  LieferterminContainer: 'date',
  NaechsteKw: 'boolean',
  NlSp: 'string',
  NlSpPos: 'string',
  Plombe: 'string',
  PoD: 'string',
  Rechnungen: 'string',
  Reeder: 'string',
  RueckgabeReferenz: 'string',
  Schiff: 'string',
  Spediteur: 'string',
  TerminBestaetigungCif: 'boolean',
  ...baseEntityFieldTypes,
};
